<script lang="ts" setup>
  import type { Nullable } from '~/core/types'

  type Props = {
    observedElement?: Nullable<HTMLElement>
    observedElementId?: string
    threshold?: number
    speed?: number
    margin?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    margin: '0px 0px 0px 0px',
    threshold: 1,
    speed: 0.5,
  })

  const emit = defineEmits<{
    (e: 'change'): void
  }>()

  const observedElementRef = ref<Nullable<HTMLElement>>(null)
  const collapsed = ref(false)

  function onIntersectionObserverEvent(intersectionObserverEntries: IntersectionObserverEntry[]) {
    const intersectionEvent = intersectionObserverEntries[0]
    const shouldCollapse = intersectionEvent.intersectionRatio <= props.threshold
    collapsed.value = collapsed.value ? false : shouldCollapse
    emit('change')
  }

  watch(observedElementRef, (element) => {
    if (!element) {
      return
    }
    const options = {
      rootMargin: props.margin,
      threshold: props.threshold,
    }
    const observer = new IntersectionObserver(onIntersectionObserverEvent, options)
    observer.observe(element)
  }, { immediate: true })

  // Update de la ref si element
  watch(() => props.observedElement, (element) => {
    observedElementRef.value = element ?? null
  }, { immediate: true })

  // Update de la ref si elementId
  onMounted(() => {
    if (props.observedElementId) {
      observedElementRef.value = document.getElementById(props.observedElementId)
    }
  })
</script>

<template>
  <div
    class="c-scroll-reactive"
    :class="{ collapsed: collapsed }"
  >
    <slot :collapsed="collapsed" />
  </div>
</template>

<style scoped>
.c-scroll-reactive {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}
</style>
